export default __webpack_public_path__ + "static/media/fifteen.58a4fdd5.jpg";